export default __webpack_public_path__ + "static/media/buyer-completed.aa46e010.svg";